import React from 'react';

interface BodyWrapperProps {
  children?: React.ReactNode;
}

export const BodyWrapper = (props: BodyWrapperProps) => {
  return (
    <main className="flex-grow relative bg-gray-gray200 laptop:px-32 tablet:px-8 mobile:px-2 pt-3">
      {props.children}
    </main>
  );
};
